import request from '@/utils/request'
import service from '@/utils/request'

export function userLogin(params) {
    return request({
        url: "/Login",
        method: 'get',
        params: params
    });
}

export async function refresh(data){
    return await service.post("/Refresh", data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export function loginOut() {
    return request({
        url: "/LoginOut",
        method: 'get'
    });
}

export function getListPage(controllerName,params) {
    return request({
        url: "/"+controllerName +"/GetListPage",
        method: 'get',
        params: params,
        timeout: 60000
    });
}

export function getListPageByEquipmentId(controllerName, params) {
    return request({
        url: "/" + controllerName + "/GetListPageByEquipmentId",
        method: 'get',
        params: params
    });
}

export function getEntityFull(controllerName, params) {
    return request({
        url: "/" + controllerName + "/GetEntityFull",
        method: 'get',
        params: params
    });
}

// export function tableInfo(params) {
//     return request({
//         url: "/TableInfo",
//         method: 'get',
//         params: params
//     });
// }

export function tableInfo2(params) {
    return request({
        url: "/TableInfo/v2",
        method: 'get',
        params: params
    });
}

export function updateEntity(controllerName, data) {
    return request({
        url: "/" + controllerName + "/EditEntity",
        method: 'post',
        data: data
    });
}

export function newEntity(controllerName, data) {
    return request({
        url: "/" + controllerName + "/AddEntity",
        method: 'post',
        data: data
    });
}

export function deleteEntity(controllerName, data) {
    return request({
        url: "/" + controllerName + "/DeleteEntity",
        method: 'post',
        data: data
    });
}

export function GetLineChart(controllerName,params) {
    return request({
        url: "/" + controllerName + "/GetLineChart",
        method: 'get',
        params: params
    });
}

export function GetRecentlyData(){
    return request({
        url: "/MicroObservation/GetRecentlyData",
        method: 'get'
    })
}

export function Uploader(data) {
    return request({
        url: "/FileUpload/Uploader",
        method: 'post',
        headers: {
            'Content-Type':'multipart/form-data;charset=UTF-8'
        },
        data: data,
        timeout: 6000000    // 100分钟
    });
}

// export function UploaderAttachment(data) {
//     return request({
//         url: "/Attachment/Uploader",
//         method: 'post',
//         headers: {
//             'Content-Type': 'multipart/form-data;charset=UTF-8'
//         },
//         data: data
//     });
// }

export function Calc(params) {
    return request({
        url: "/Observation/Calc",
        method: 'get',
        params: params,
        timeout: 6000000   // 100分钟
    });
}

export function UpdateCalcId(params) {
    return request({
        url: "/Observation/UpdateCalcId",
        method: 'get',
        params: params
    });
}

export function getCalcList(params) {
    return request({
        url: "/Observation/GetCalcList",
        method: 'get',
        params: params
    });
}

export function getEntityFullByCalcId(params) {
    return request({
        url: "/Observation/GetEntityFullByCalcId",
        method: 'get',
        params: params
    });
}

export function generateDataset(params) {
    return request({
        url: "/Sample/GenerateDataset",
        method: 'get',
        params: params,
        timeout: 6000000    // 100分钟
    });
}

export function getDataFile(controllerName,params) {
    return request({
        //url: "/Observation/GetDataFile",
        url: "/" + controllerName + "/GetDataFile",
        method: 'get',
        responseType: 'blob',
        params: params
    });
}

export function getAttachFile(params) {
    return request({
        url: "/Attachment/GetFile",
        method: 'get',
        responseType: 'blob',
        params: params
    });
}

//下载文件
export function downloadFile(res) {
    const blob = new Blob([res.data], { type: res.data.type });
    const urldown = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = urldown;
    a.download = decodeURIComponent(res.headers.filename);
    a.click();
    window.URL.revokeObjectURL(urldown);
}

export function getTreeJson(controllerName, params) {
    return request({
        url: "/" + controllerName + "/GetTreeJson",
        method: 'get',
        params: params
    });
}

// export function getCompanyAttachmentData(id){
//     return request({
//         url: "/RegulatedCompany/GetAttachments",
//         method: "get",
//         params: {id: id}
//     });
// }

export function getAttachmentData(tableName, id){
    return request({
        url: "/" + tableName + "/GetAttachments",
        method: "get",
        params: {id: id},
        timeout: 60000
    });
}

// export function addCompanyAttchmentIds(id, attachmentIds){
//     return request({
//         url: "/RegulatedCompany/AddAttachments",
//         method: "get",
//         params: {id: id, attachmentIds: attachmentIds}
//     });
// }
//
// export function deleteCompanyAttchmentIds(id, attachmentIds){
//     return request({
//         url: "/RegulatedCompany/DeleteAttachments",
//         method: "get",
//         params: {id: id, attachmentIds: attachmentIds}
//     });
// }

export function deleteAttachment(id, targetId, targetName){
    return request({
        url: "/Attachment/DeleteAttachment",
        method: "get",
        params: {id: id, targetId: targetId, targetName: targetName}
    });
}

export function getAttachFiles(ids, outputFilename){
    let idsStr = '[' + ids.join(',') + ']';
    return request({
        url: "/Attachment/GetFiles",
        method: "get",
        responseType: 'blob',
        params: { ids: idsStr, outputFilename: outputFilename }
    });
}
